import { defineStore } from 'pinia'

export interface PackageItem {
  amount: string
  description: string
  id: number
  mDescription: string
  title: string
  imgSrc?: string
}
interface Packages {
  packages: PackageItem[]
}
const STORE_NAME = 'packagesStore'

export const usePackagesStore = defineStore(STORE_NAME, {
  state: (): Packages => ({
    packages: []
  }),
  persist: false,
  actions: {
    setPackages(data: PackageItem[]) {
      this.packages = data
    }
  }
})
